import {INPOST_CARRIER} from 'modules/checkout'

export const PICKUP_ALLOWED_METHODS = [INPOST_CARRIER] as const
export const COURIER_NOT_ALLOWED_METHODS = ['flatrate2']
export const PICKUP_NOT_ALLOWED_METHODS = ['pickup']
export const APPLE_PAY_API_VERSION = 3
